module.exports = __webpack_public_path__ + "img/w18-b2.cad21390.jpg";